import { render } from "./taskModal.vue?vue&type=template&id=251761bc&scoped=true&ts=true"
import script from "./taskModal.vue?vue&type=script&lang=ts"
export * from "./taskModal.vue?vue&type=script&lang=ts"

import "./taskModal.vue?vue&type=style&index=0&id=251761bc&scoped=true&lang=css"

import exportComponent from "C:\\projects\\totalrender\\onofficeapp\\marketplaceapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-251761bc"]])

export default __exports__